import { Component, OnInit, Input } from '@angular/core';
import { SessionExpiredService } from 'app/core/services/session_expired/session_expired.service';

@Component({
  selector: 'session-expired-model',
  templateUrl: './session-expired-model.component.html',
  styleUrls: ['./session-expired-model.component.scss']
})
export class SessionExpiredComponent implements OnInit {

  constructor() {}

  ngOnInit(): void { }

}
